export const columns = function () {
  // 日期，机构名称，报价个数，报价金额，出单个数，出单金额，净费，实收金额，返费
  return [
    // {
    //   prop: "date",
    //   label: "日期",
    //   minWidth: 100,
    // },
    {
      prop: "orgName",
      label: "机构名称",
      minWidth: 100,
    },
    {
      prop: "outNum",
      label: "出单个数",
	  sortable: true,
      minWidth: 100,
    },
    {
      prop: "outAmount",
      label: "出单金额",
      minWidth: 100,
    },
	{
	  prop: "baoNum",
	  label: "报价个数",
	  sortable: true,
	  minWidth: 100,
	},
	{
	  prop: "kaiNum",
	  label: "开码个数",
	  sortable: true,
	  minWidth: 100,
	},
	{
	  prop: "corNum",
	  label: "批单个数",
	  sortable: true,
	  minWidth: 100,
	},
	{
	  prop: "corAmount",
	  label: "批单金额",
	  minWidth: 100,
	},
    {
      prop: "netFee",
      label: "净费",
      minWidth: 100,
    },
    {
      prop: "actualAmount",
      label: "实收金额",
      minWidth: 100,
    },
    // {
    //   prop: "returnAmount",
    //   label: "返费",
    //   minWidth: 100,
    // },
  ];
};

export default {};
